
export class UnloadingSpecies {


  speciesName: string = '';

  poundsLanded!: number

  landingReceipt: string = '';


  constructor() {

  }



  static transformAnonymous(anon: any): UnloadingSpecies {
    let us = new UnloadingSpecies();
    us.speciesName = anon.speciesName;
    us.poundsLanded = anon.poundsLanded;
    us.landingReceipt = anon.landingReceipt;
    return us;
  }

}
